import {
  type OrderGetOrderDetailsReadDto,
  type OrderItemDetailsOrderReadDto,
} from "@/config/apiClient";

/**
 * Gets the original order item from the list of order items
 *
 * Returns the oldest order item that is not the current one.
 * This is useful for modification requests where you need to compare
 * with the original item.
 */
export const getOriginalOrderItem = (
  order: OrderGetOrderDetailsReadDto | OrderItemDetailsOrderReadDto,
  currentOrderItemId: string
) => {
  const otherOrderItems = order.OrderItem.filter(
    (oi) => oi.id !== currentOrderItemId
  );

  if (otherOrderItems.length === 0) {
    return undefined;
  }

  // Sort by creation date (ascending) and return the oldest one
  const sortedItems = otherOrderItems.toSorted(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );

  return sortedItems[0];
};
